import { render } from "./RecordingsTable.vue?vue&type=template&id=0a75b2e2&scoped=true"
import script from "./RecordingsTable.vue?vue&type=script&lang=js"
export * from "./RecordingsTable.vue?vue&type=script&lang=js"

import "./RecordingsTable.vue?vue&type=style&index=0&id=0a75b2e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a75b2e2"]])

export default __exports__